import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateSubdivisioneForm } from '../Validations/ValidationsSubdivisione';

export default function EditSubdivisioneForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ id: '', descripcion: '', divisioneId: '' });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSubdivisione = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`/subdivisiones/${id}`);
        setFormData({
          id: response.data.id || '',
          descripcion: response.data.descripcion || '',
          divisioneId: response.data.divisioneId || ''
        });
      } catch (err) {
        setError('Error al cargar los datos de la subdivisión.');
      } finally {
        setIsLoading(false);
      }
    };

    if (id) fetchSubdivisione();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
    setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await validateSubdivisioneForm(formData);
    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      setError(null);
      try {
        await axios.put(`/subdivisiones/${id}`, formData);
        navigate('/home/subdivisiones');
      } catch (err) {
        setError('Error al actualizar la zona. Por favor, intente de nuevo.');
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="max-w-lg mx-auto mt-10 bg-green-100 p-8 rounded-lg shadow-lg border border-green-300">
      <h2 className="text-3xl font-bold text-green-700 mb-6 text-center">Editar Zona</h2>
      {isLoading && <div className="text-center text-green-600">Cargando...</div>}
      {error && <div className="text-center text-red-500">{error}</div>}
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-green-700 font-medium">ID</label>
          <input
            type="text"
            name="id"
            value={formData.id}
            className="w-full p-3 border rounded-lg bg-gray-200 text-gray-700 cursor-not-allowed"
            readOnly
          />
        </div>
        <div>
          <label className="block text-green-700 font-medium">Descripción</label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 ${errors.descripcion ? 'border-red-500' : 'border-green-300'}`}
            required
          />
          {errors.descripcion && <p className="text-red-500 text-sm mt-1">{errors.descripcion}</p>}
        </div>
        <div>
          <label className="block text-green-700 font-medium">ID zona</label>
          <input
            type="text"
            name="divisioneId"
            value={formData.divisioneId}
            onChange={handleChange}
            className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 ${errors.divisioneId ? 'border-red-500' : 'border-green-300'}`}
            required
          />
          {errors.divisioneId && <p className="text-red-500 text-sm mt-1">{errors.divisioneId}</p>}
        </div>
        <button
          type="submit"
          className="w-full bg-green-500 text-white p-3 rounded-lg hover:bg-green-600 transition-all"
          disabled={isLoading}
        >
          {isLoading ? 'Actualizando...' : 'Actualizar zona'}
        </button>
      </form>
    </div>
  );
}
